import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { TranslocoService } from '@ngneat/transloco';
import {
  UpdateUserAppSettingsDto,
  UserAppSettingsDto,
} from '@splitsecondconnect/ultramarine-shared';
import { UserAppSettingsService } from '../services/user-app-settings.service';
import { AlertsService } from '../services/alerts.service';
import { httpErrorMessage } from '../helpers/http-error-message';
import { catchError, finalize, of, tap } from 'rxjs';

interface UserAppSettingsState {
  isUserAppSettingsLoading: boolean;
  isUserAppSettingsSaving: boolean;
  userAppSettings: UserAppSettingsDto | undefined;
}

const initialState: UserAppSettingsState = {
  isUserAppSettingsLoading: false,
  isUserAppSettingsSaving: false,
  userAppSettings: undefined,
};

export const UserAppSettingsStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(
    (
      store,
      userAppSettingsService = inject(UserAppSettingsService),
      transloco = inject(TranslocoService),
      alerts = inject(AlertsService),
    ) => ({
      load() {
        patchState(store, { isUserAppSettingsLoading: true });
        return userAppSettingsService.getSettings().pipe(
          tap((res) => {
            patchState(store, { userAppSettings: res.data });
          }),
          catchError(() => of(null)),
          finalize(() =>
            patchState(store, { isUserAppSettingsLoading: false }),
          ),
        );
      },
      replaceSettings(dto: UpdateUserAppSettingsDto) {
        patchState(store, { isUserAppSettingsSaving: true });
        return userAppSettingsService.replaceSettings(dto).pipe(
          tap((res) => {
            patchState(store, { userAppSettings: res.data });
          }),
          catchError((error) => {
            void alerts.error(
              httpErrorMessage(
                error,
                transloco.translate('alerts|something-went-wrong'),
              ),
            );
            return of(null);
          }),
          finalize(() => patchState(store, { isUserAppSettingsSaving: false })),
        );
      },
    }),
  ),
);
